import SSTIcon from './SST.svg';
import CVSIcon from './CVS.svg';
import SAFTIcon from './SAFT.svg';
import PTONIcon from './PTON.svg';
import ABTIcon from './ABT.svg';
import JPMIcon from './JPM.svg';
import FEIcon from './FE.svg';
import COFIcon from './COF.svg';
import BAFNIcon from './BAFN.svg';
import MRNAIcon from './MRNA.svg';
import HSTIcon from './HST.svg';
import IMGNIcon from './IMGN.svg';
import ELANIcon from './ELAN.svg';
import CVNAIcon from './CVNA.svg';
import VTRSIcon from './VTRS.svg';
import NVSTIcon from './NVST.svg';
import KREFIcon from './KREF.svg';
import AKAMIcon from './AKAM.svg';
import BERYIcon from './BERY.svg';
import BHCIcon from './BHC.svg';
import LILAKIcon from './LILAK.svg';
import ROLIcon from './ROL.svg';
import OWLIcon from './OWL.svg';
import TSLAIcon from './TSLA.svg';
import CNCIcon from './CNC.svg';
import BFAMIcon from './BFAM.svg';
import MATIcon from './MAT.svg';
import FOURIcon from './FOUR.svg';
import UNITIcon from './UNIT.svg';
import DHRIcon from './DHR.svg';
import SRIcon from './SR.svg';
import COPIcon from './COP.svg';
import CPNGIcon from './CPNG.svg';
import SPYIcon from './SPY.svg';
import CVEIcon from './CVE.svg';
import RIVNIcon from './RIVN.svg';
import ILMNIcon from './ILMN.svg';
import VYNEIcon from './VYNE.svg';
import AALIcon from './AAL.svg';
import PATHIcon from './PATH.svg';
import METAIcon from './META.svg';
import GPROIcon from './GPRO.svg';
import PKIcon from './PK.svg';
import SGIcon from './SG.svg';
import ETRNIcon from './ETRN.svg';
import DDDIcon from './DDD.svg';
import VTEXIcon from './VTEX.svg';
import BYNDIcon from './BYND.svg';
import GOOGLIcon from './GOOGL.svg';
import SNOWIcon from './SNOW.svg';
import BLNKIcon from './BLNK.svg';
import BRXIcon from './BRX.svg';
import PROKIcon from './PROK.svg';
import JOBYIcon from './JOBY.svg';
import ANETIcon from './ANET.svg';
import SPIRIcon from './SPIR.svg';
import DOCNIcon from './DOCN.svg';
import PXDIcon from './PXD.svg';
import SPRXIcon from './SPRX.svg';
import ZYXIIcon from './ZYXI.svg';
import RCLIcon from './RCL.svg';
import LHXIcon from './LHX.svg';
import RACEIcon from './RACE.svg';
import HNSTIcon from './HNST.svg';
import COTYIcon from './COTY.svg';
import FOXAIcon from './FOXA.svg';
import TDOCIcon from './TDOC.svg';
import NYCBIcon from './NYCB.svg';
import SQIcon from './SQ.svg';
import CRWDIcon from './CRWD.svg';
import DXIcon from './DX.svg';
import LCIDIcon from './LCID.svg';
import GTIcon from './GT.svg';
import CZRIcon from './CZR.svg';
import QGENIcon from './QGEN.svg';
import SAGEIcon from './SAGE.svg';
import TWOIcon from './TWO.svg';
import HLIcon from './HL.svg';
import SHOPIcon from './SHOP.svg';
import AMNIcon from './AMN.svg';
import VNOIcon from './VNO.svg';
import FISIcon from './FIS.svg';
import ABRIcon from './ABR.svg';
import RFIcon from './RF.svg';
import MASIcon from './MAS.svg';
import SUIcon from './SU.svg';
import OUTIcon from './OUT.svg';
import TSLQIcon from './TSLQ.svg';
import ACLSIcon from './ACLS.svg';
import ENBIcon from './ENB.svg';
import SIRIIcon from './SIRI.svg';
import ARMKIcon from './ARMK.svg';
import BIRDIcon from './BIRD.svg';
import BSYIcon from './BSY.svg';
import NKEIcon from './NKE.svg';
import VSTSIcon from './VSTS.svg';
import BSXIcon from './BSX.svg';
import USBIcon from './USB.svg';
import IBMIcon from './IBM.svg';
import PLDIcon from './PLD.svg';
import RCIIcon from './RCI.svg';
import ALGMIcon from './ALGM.svg';
import LKQIcon from './LKQ.svg';
import EOGIcon from './EOG.svg';
import ETSYIcon from './ETSY.svg';
import AMCRIcon from './AMCR.svg';
import FROIcon from './FRO.svg';
import TOSTIcon from './TOST.svg';
import KRIcon from './KR.svg';
import REALIcon from './REAL.svg';
import TTDIcon from './TTD.svg';
import SOFIIcon from './SOFI.svg';
import GSIcon from './GS.svg';
import SHAKIcon from './SHAK.svg';
import ELIcon from './EL.svg';
import CLXIcon from './CLX.svg';
import PMIcon from './PM.svg';
import CNPIcon from './CNP.svg';
import FOXFIcon from './FOXF.svg';
import PANWIcon from './PANW.svg';
import RVMDIcon from './RVMD.svg';
import KMBIcon from './KMB.svg';
import NEMIcon from './NEM.svg';
import HIMSIcon from './HIMS.svg';
import IACIcon from './IAC.svg';
import PEAKIcon from './PEAK.svg';
import CTVAIcon from './CTVA.svg';
import WFCIcon from './WFC.svg';
import BRKRIcon from './BRKR.svg';
import LULUIcon from './LULU.svg';
import WENIcon from './WEN.svg';
import LPXIcon from './LPX.svg';
import ETNIcon from './ETN.svg';
import SWTXIcon from './SWTX.svg';
import FLEXIcon from './FLEX.svg';
import NFLXIcon from './NFLX.svg';
import ALGNIcon from './ALGN.svg';
import DELLIcon from './DELL.svg';
import QSRIcon from './QSR.svg';
import CNQIcon from './CNQ.svg';
import DISIcon from './DIS.svg';
import MTGIcon from './MTG.svg';
import CGNXIcon from './CGNX.svg';
import GEIcon from './GE.svg';
import CBREIcon from './CBRE.svg';
import AMHIcon from './AMH.svg';
import SRCIcon from './SRC.svg';
import PTENIcon from './PTEN.svg';
import MAIcon from './MA.svg';
import AIGIcon from './AIG.svg';
import CPGIcon from './CPG.svg';
import SONDIcon from './SOND.svg';
import AESIcon from './AES.svg';
import BNIcon from './BN.svg';
import XIcon from './X.svg';
import TTWOIcon from './TTWO.svg';
import VICIIcon from './VICI.svg';
import OIcon from './O.svg';
import HONIcon from './HON.svg';
import WAFDIcon from './WAFD.svg';
import DOCIcon from './DOC.svg';
import SLBIcon from './SLB.svg';
import TGTIcon from './TGT.svg';
import DUOLIcon from './DUOL.svg';
import ALLYIcon from './ALLY.svg';
import PLTRIcon from './PLTR.svg';
import DDOGIcon from './DDOG.svg';
import EQRIcon from './EQR.svg';
import WMBIcon from './WMB.svg';
import UTHRIcon from './UTHR.svg';
import MODGIcon from './MODG.svg';
import CTRNIcon from './CTRN.svg';
import LITEIcon from './LITE.svg';
import WMTIcon from './WMT.svg';
import KKRIcon from './KKR.svg';
import LMTIcon from './LMT.svg';
import BAXIcon from './BAX.svg';
import KIMIcon from './KIM.svg';
import EDRIcon from './EDR.svg';
import KEYIcon from './KEY.svg';
import OPKIcon from './OPK.svg';
import OTISIcon from './OTIS.svg';
import ZIIcon from './ZI.svg';
import STNEIcon from './STNE.svg';
import AAPLIcon from './AAPL.svg';
import SMGIcon from './SMG.svg';
import WYIcon from './WY.svg';
import TUIcon from './TU.svg';
import DNUTIcon from './DNUT.svg';
import BXIcon from './BX.svg';
import ADVIcon from './ADV.svg';
import AERIcon from './AER.svg';
import TMUSIcon from './TMUS.svg';
import KVYOIcon from './KVYO.svg';
import HASIcon from './HAS.svg';
import SWIIcon from './SWI.svg';
import DNMRIcon from './DNMR.svg';
import CPSIcon from './CPS.svg';
import MUIcon from './MU.svg';
import SWKIcon from './SWK.svg';
import AEPIcon from './AEP.svg';
import LIcon from './L.svg';
import AAIcon from './AA.svg';
import MRDBIcon from './MRDB.svg';
import DOWIcon from './DOW.svg';
import ASANIcon from './ASAN.svg';
import VRTIcon from './VRT.svg';
import LILAIcon from './LILA.svg';
import PSAIcon from './PSA.svg';
import BMYIcon from './BMY.svg';
import CARTIcon from './CART.svg';
import BAMIcon from './BAM.svg';
import CFLTIcon from './CFLT.svg';
import SPLKIcon from './SPLK.svg';
import ARRYIcon from './ARRY.svg';
import NNNIcon from './NNN.svg';
import HEROIcon from './HERO.svg';
import GFLIcon from './GFL.svg';
import LRCXIcon from './LRCX.svg';
import BWAIcon from './BWA.svg';
import UAAIcon from './UAA.svg';
import NWLIcon from './NWL.svg';
import TELLIcon from './TELL.svg';
import NXTIcon from './NXT.svg';
import ROKUIcon from './ROKU.svg';
import PPLIcon from './PPL.svg';
import BMOIcon from './BMO.svg';
import LACIcon from './LAC.svg';
import BLKIcon from './BLK.svg';
import JNJIcon from './JNJ.svg';
import BALLIcon from './BALL.svg';
import MULNIcon from './MULN.svg';
import FTIIcon from './FTI.svg';
import WMIcon from './WM.svg';
import MIcon from './M.svg';
import STWDIcon from './STWD.svg';
import ZIcon from './Z.svg';
import CRMIcon from './CRM.svg';
import EXTRIcon from './EXTR.svg';
import CLVTIcon from './CLVT.svg';
import DWACIcon from './DWAC.svg';
import AVGOIcon from './AVGO.svg';
import SWNIcon from './SWN.svg';
import RBLXIcon from './RBLX.svg';
import VFCIcon from './VFC.svg';
import SFIXIcon from './SFIX.svg';
import CLIcon from './CL.svg';
import DNAIcon from './DNA.svg';
import JCIIcon from './JCI.svg';
import UAIcon from './UA.svg';
import VZIcon from './VZ.svg';
import FSLRIcon from './FSLR.svg';
import NYTIcon from './NYT.svg';
import IONQIcon from './IONQ.svg';
import GOOGIcon from './GOOG.svg';
import PLUGIcon from './PLUG.svg';
import LYVIcon from './LYV.svg';
import EQTIcon from './EQT.svg';
import PFEIcon from './PFE.svg';
import KSSIcon from './KSS.svg';
import NTNXIcon from './NTNX.svg';
import SBRAIcon from './SBRA.svg';
import LBTYBIcon from './LBTYB.svg';
import SPOTIcon from './SPOT.svg';
import IFFIcon from './IFF.svg';
import RRCIcon from './RRC.svg';
import EGOIcon from './EGO.svg';
import IRTIcon from './IRT.svg';
import GPSIcon from './GPS.svg';
import XPIcon from './XP.svg';
import AMGNIcon from './AMGN.svg';
import VSTIcon from './VST.svg';
import CUBEIcon from './CUBE.svg';
import TDIcon from './TD.svg';
import GROWIcon from './GROW.svg';
import ARIcon from './AR.svg';
import CMIcon from './CM.svg';
import HIcon from './H.svg';
import CRHIcon from './CRH.svg';
import MQIcon from './MQ.svg';
import ONIcon from './ON.svg';
import MSIcon from './MS.svg';
import AGIcon from './AG.svg';
import SYFIcon from './SYF.svg';
import OKEIcon from './OKE.svg';
import BKIcon from './BK.svg';
import OSCRIcon from './OSCR.svg';
import DISAIcon from './DISA.svg';
import DNBIcon from './DNB.svg';
import ZMIcon from './ZM.svg';
import GOOSIcon from './GOOS.svg';
import RKTIcon from './RKT.svg';
import BNSIcon from './BNS.svg';
import GOODIcon from './GOOD.svg';
import DASHIcon from './DASH.svg';
import QCOMIcon from './QCOM.svg';
import CAREIcon from './CARE.svg';
import ARKKIcon from './ARKK.svg';
import CARRIcon from './CARR.svg';
import ROSTIcon from './ROST.svg';
import GISIcon from './GIS.svg';
import LUVIcon from './LUV.svg';
import LBTYAIcon from './LBTYA.svg';
import RDNTIcon from './RDNT.svg';
import NCLHIcon from './NCLH.svg';
import ZIONIcon from './ZION.svg';
import COHRIcon from './COHR.svg';
import LXPIcon from './LXP.svg';
import MARAIcon from './MARA.svg';
import TEAMIcon from './TEAM.svg';
import KGCIcon from './KGC.svg';
import UNHIcon from './UNH.svg';
import HBANIcon from './HBAN.svg';
import NXEIcon from './NXE.svg';
import HASIIcon from './HASI.svg';
import DALIcon from './DAL.svg';
import TEXIcon from './TEX.svg';
import TFCIcon from './TFC.svg';
import APAIcon from './APA.svg';
import JWNIcon from './JWN.svg';
import KIcon from './K.svg';
import IBKRIcon from './IBKR.svg';
import FNVIcon from './FNV.svg';
import CRKIcon from './CRK.svg';
import NIIcon from './NI.svg';
import CSXIcon from './CSX.svg';
import AJXIcon from './AJX.svg';
import STZIcon from './STZ.svg';
import HALIcon from './HAL.svg';
import HOGIcon from './HOG.svg';
import FIcon from './F.svg';
import ADIIcon from './ADI.svg';
import AEMIcon from './AEM.svg';
import CCIcon from './CC.svg';
import PARAIcon from './PARA.svg';
import RPRXIcon from './RPRX.svg';
import ADBEIcon from './ADBE.svg';
import HTZIcon from './HTZ.svg';
import TECHIcon from './TECH.svg';
import GOLDIcon from './GOLD.svg';
import RIGIcon from './RIG.svg';
import ROIVIcon from './ROIV.svg';
import SPXSIcon from './SPXS.svg';
import ARKGIcon from './ARKG.svg';
import TENXIcon from './TENX.svg';
import LYFTIcon from './LYFT.svg';
import GTLSIcon from './GTLS.svg';
import FRSHIcon from './FRSH.svg';
import WBDIcon from './WBD.svg';
import NOVIcon from './NOV.svg';
import NOWIcon from './NOW.svg';
import PEPIcon from './PEP.svg';
import GOAUIcon from './GOAU.svg';
import LLYIcon from './LLY.svg';
import HUBCIcon from './HUBC.svg';
import FLNGIcon from './FLNG.svg';
import COSTIcon from './COST.svg';
import GPKIcon from './GPK.svg';
import XPOIcon from './XPO.svg';
import LSPDIcon from './LSPD.svg';
import CPRTIcon from './CPRT.svg';
import SMCIIcon from './SMCI.svg';
import UWMCIcon from './UWMC.svg';
import ULTAIcon from './ULTA.svg';
import MPWIcon from './MPW.svg';
import UPSTIcon from './UPST.svg';
import CRSRIcon from './CRSR.svg';
import KVUEIcon from './KVUE.svg';
import QRTEAIcon from './QRTEA.svg';
import TSNIcon from './TSN.svg';
import LMNDIcon from './LMND.svg';
import XELIcon from './XEL.svg';
import HCPIcon from './HCP.svg';
import RKDAIcon from './RKDA.svg';
import CRSPIcon from './CRSP.svg';
import XRAYIcon from './XRAY.svg';
import FTVIcon from './FTV.svg';
import METIcon from './MET.svg';
import LAMRIcon from './LAMR.svg';
import TECKIcon from './TECK.svg';
import MDLZIcon from './MDLZ.svg';
import AEHRIcon from './AEHR.svg';
import LOWIcon from './LOW.svg';
import HYMCIcon from './HYMC.svg';
import BTEIcon from './BTE.svg';
import NLYIcon from './NLY.svg';
import SNDLIcon from './SNDL.svg';
import NOCIcon from './NOC.svg';
import COINIcon from './COIN.svg';
import DFARIcon from './DFAR.svg';
import UTIIcon from './UTI.svg';
import CVEOIcon from './CVEO.svg';
import ONONIcon from './ONON.svg';
import UVVIcon from './UVV.svg';
import ABNBIcon from './ABNB.svg';
import KHCIcon from './KHC.svg';
import IPGIcon from './IPG.svg';
import BARIcon from './BAR.svg';
import UBSIcon from './UBS.svg';
import UNGIcon from './UNG.svg';
import ABBVIcon from './ABBV.svg';
import BILLIcon from './BILL.svg';
import GOLFIcon from './GOLF.svg';
import CHWYIcon from './CHWY.svg';
import FASTIcon from './FAST.svg';
import SNAIcon from './SNA.svg';
import TJXIcon from './TJX.svg';
import CRDOIcon from './CRDO.svg';
import BXMTIcon from './BXMT.svg';
import SIcon from './S.svg';
import MRKIcon from './MRK.svg';
import BEIcon from './BE.svg';
import DIcon from './D.svg';
import AIIcon from './AI.svg';
import AEOIcon from './AEO.svg';
import MPCIcon from './MPC.svg';
import STXIcon from './STX.svg';
import SONOIcon from './SONO.svg';
import QRTEBIcon from './QRTEB.svg';
import NUIcon from './NU.svg';
import AMSCIcon from './AMSC.svg';
import DVNIcon from './DVN.svg';
import TPRIcon from './TPR.svg';
import BRKBIcon from './BRK.B.svg';
import BAIcon from './BA.svg';
import MROIcon from './MRO.svg';
import ASTCIcon from './ASTC.svg';
import WIcon from './W.svg';
import AMIcon from './AM.svg';
import SANDIcon from './SAND.svg';
import AQNIcon from './AQN.svg';
import MDBIcon from './MDB.svg';
import GILDIcon from './GILD.svg';
import MBLYIcon from './MBLY.svg';
import XELAIcon from './XELA.svg';
import SITCIcon from './SITC.svg';
import HUBSIcon from './HUBS.svg';
import BRZEIcon from './BRZE.svg';
import CSCOIcon from './CSCO.svg';
import TROWIcon from './TROW.svg';
import UALIcon from './UAL.svg';
import UVEIcon from './UVE.svg';
import LBTYKIcon from './LBTYK.svg';
import GTLBIcon from './GTLB.svg';
import PPSIIcon from './PPSI.svg';
import SWKSIcon from './SWKS.svg';
import CTRAIcon from './CTRA.svg';
import ENPHIcon from './ENPH.svg';
import MCHPIcon from './MCHP.svg';
import PAGPIcon from './PAGP.svg';
import MDTIcon from './MDT.svg';
import AIcon from './A.svg';
import ALIcon from './AL.svg';
import VIcon from './V.svg';
import MOIcon from './MO.svg';
import FLTIcon from './FLT.svg';
import GRABIcon from './GRAB.svg';
import FOXIcon from './FOX.svg';
import AMPLIcon from './AMPL.svg';
import ESGEIcon from './ESGE.svg';
import CFIcon from './CF.svg';
import TIcon from './T.svg';
import BRKAIcon from './BRK.A.svg';
import BBIcon from './BB.svg';
import MGMIcon from './MGM.svg';
import WTIcon from './WT.svg';
import SAVAIcon from './SAVA.svg';
import ACHRIcon from './ACHR.svg';
import EIXIcon from './EIX.svg';
import KDPIcon from './KDP.svg';
import MORFIcon from './MORF.svg';
import BBYIcon from './BBY.svg';
import LBRTIcon from './LBRT.svg';
import CASHIcon from './CASH.svg';
import OPENIcon from './OPEN.svg';
import LVSIcon from './LVS.svg';
import WBAIcon from './WBA.svg';
import GENIcon from './GEN.svg';
import BTUIcon from './BTU.svg';
import EEMIcon from './EEM.svg';
import BACIcon from './BAC.svg';
import SNPOIcon from './SNPO.svg';
import GPNIcon from './GPN.svg';
import PSXIcon from './PSX.svg';
import FSLYIcon from './FSLY.svg';
import DARIcon from './DAR.svg';
import STLAIcon from './STLA.svg';
import TQQQIcon from './TQQQ.svg';
import SQSPIcon from './SQSP.svg';
import CFGIcon from './CFG.svg';
import PAGSIcon from './PAGS.svg';
import WUIcon from './WU.svg';
import APHIcon from './APH.svg';
import FCXIcon from './FCX.svg';
import MSIIcon from './MSI.svg';
import UIcon from './U.svg';
import SYYIcon from './SYY.svg';
import MLIcon from './ML.svg';
import SVVIcon from './SVV.svg';
import OGNIcon from './OGN.svg';
import HPIcon from './HP.svg';
import UBERIcon from './UBER.svg';
import EWIcon from './EW.svg';
import ZFOXIcon from './ZFOX.svg';
import SHCOIcon from './SHCO.svg';
import CMGIcon from './CMG.svg';
import CCLIcon from './CCL.svg';
import AMATIcon from './AMAT.svg';
import LOGIIcon from './LOGI.svg';
import HPQIcon from './HPQ.svg';
import MSFTIcon from './MSFT.svg';
import CTLTIcon from './CTLT.svg';
import UDRIcon from './UDR.svg';
import BIRKIcon from './BIRK.svg';
import OKTAIcon from './OKTA.svg';
import ABSIIcon from './ABSI.svg';
import DOCSIcon from './DOCS.svg';
import NXPIIcon from './NXPI.svg';
import RTXIcon from './RTX.svg';
import WHRIcon from './WHR.svg';
import WRBYIcon from './WRBY.svg';
import NDAQIcon from './NDAQ.svg';
import MTCHIcon from './MTCH.svg';
import PINSIcon from './PINS.svg';
import SEDGIcon from './SEDG.svg';
import OVVIcon from './OVV.svg';
import ESTCIcon from './ESTC.svg';
import CARIcon from './CAR.svg';
import DKNGIcon from './DKNG.svg';
import BMRNIcon from './BMRN.svg';
import QSIcon from './QS.svg';
import EAIcon from './EA.svg';
import AMDIcon from './AMD.svg';
import VLTOIcon from './VLTO.svg';
import KOSSIcon from './KOSS.svg';
import PARAAIcon from './PARAA.svg';
import FHNIcon from './FHN.svg';
import VLOIcon from './VLO.svg';
import SPRIcon from './SPR.svg';
import ALBIcon from './ALB.svg';
import HDIcon from './HD.svg';
import HESIcon from './HES.svg';
import RITMIcon from './RITM.svg';
import BASEIcon from './BASE.svg';
import DGIcon from './DG.svg';
import FDXIcon from './FDX.svg';
import ZTSIcon from './ZTS.svg';
import VTIIcon from './VTI.svg';
import SKXIcon from './SKX.svg';
import HPEIcon from './HPE.svg';
import AXPIcon from './AXP.svg';
import SCHWIcon from './SCHW.svg';
import INCYIcon from './INCY.svg';
import CAGIcon from './CAG.svg';
import BKSYIcon from './BKSY.svg';
import NVDAIcon from './NVDA.svg';
import ROGIcon from './ROG.svg';
import LITIcon from './LIT.svg';
import DOORIcon from './DOOR.svg';
import BRFIcon from './BRF.svg';
import EXCIcon from './EXC.svg';
import MANUIcon from './MANU.svg';
import PCGIcon from './PCG.svg';
import OUSTIcon from './OUST.svg';
import CMCSAIcon from './CMCSA.svg';
import NETIcon from './NET.svg';
import PRVAIcon from './PRVA.svg';
import KOSIcon from './KOS.svg';
import BENIcon from './BEN.svg';
import FROGIcon from './FROG.svg';
import BKRIcon from './BKR.svg';
import HRLIcon from './HRL.svg';
import SOIcon from './SO.svg';
import XOMIcon from './XOM.svg';
import MRVLIcon from './MRVL.svg';
import CVXIcon from './CVX.svg';
import CNHIIcon from './CNHI.svg';
import VLYIcon from './VLY.svg';
import HOODIcon from './HOOD.svg';
import HRIcon from './HR.svg';
import NRDSIcon from './NRDS.svg';
import AMCIcon from './AMC.svg';
import DPZIcon from './DPZ.svg';
import AMTIcon from './AMT.svg';
import IRIcon from './IR.svg';
import DBIcon from './DB.svg';
import DBRGIcon from './DBRG.svg';
import JETSIcon from './JETS.svg';
import PGIcon from './PG.svg';
import QQQIcon from './QQQ.svg';
import AURIcon from './AUR.svg';
import CCJIcon from './CCJ.svg';
import SFMIcon from './SFM.svg';
import ORCLIcon from './ORCL.svg';
import GMEIcon from './GME.svg';
import EBAYIcon from './EBAY.svg';
import CHKPIcon from './CHKP.svg';
import ETRIcon from './ETR.svg';
import PENNIcon from './PENN.svg';
import SBUXIcon from './SBUX.svg';
import DOCUIcon from './DOCU.svg';
import GLWIcon from './GLW.svg';
import KMIIcon from './KMI.svg';
import BGCIcon from './BGC.svg';
import HIVEIcon from './HIVE.svg';
import AVTRIcon from './AVTR.svg';
import CATIcon from './CAT.svg';
import TSLYIcon from './TSLY.svg';
import MCDIcon from './MCD.svg';
import MNSTIcon from './MNST.svg';
import CLSIcon from './CLS.svg';
import PAASIcon from './PAAS.svg';
import RYIcon from './RY.svg';
import RIOTIcon from './RIOT.svg';
import DTIcon from './DT.svg';
import AMZNIcon from './AMZN.svg';
import GEHCIcon from './GEHC.svg';
import PTCTIcon from './PTCT.svg';
import INTCIcon from './INTC.svg';
import LOPEIcon from './LOPE.svg';
import FIIcon from './FI.svg';
import TTSHIcon from './TTSH.svg';
import TXNIcon from './TXN.svg';
import GMIcon from './GM.svg';
import PDIcon from './PD.svg';
import CLFIcon from './CLF.svg';
import RLIcon from './RL.svg';
import OXYIcon from './OXY.svg';
import TMOIcon from './TMO.svg';
import MMMIcon from './MMM.svg';
import CCIIcon from './CCI.svg';
import BBWIIcon from './BBWI.svg';
import APTVIcon from './APTV.svg';
import IDCCIcon from './IDCC.svg';
import WELLIcon from './WELL.svg';
import DXCMIcon from './DXCM.svg';
import WDCIcon from './WDC.svg';
import RVTYIcon from './RVTY.svg';
import AGNCIcon from './AGNC.svg';
import UPSIcon from './UPS.svg';
import OPADIcon from './OPAD.svg';
import NEEIcon from './NEE.svg';
import PYPLIcon from './PYPL.svg';
import EMRIcon from './EMR.svg';
import COURIcon from './COUR.svg';
import AMCXIcon from './AMCX.svg';
import AFRMIcon from './AFRM.svg';
import FTNTIcon from './FTNT.svg';
import MOSIcon from './MOS.svg';
import PRIcon from './PR.svg';
import HAYWIcon from './HAYW.svg';
import WOLFIcon from './WOLF.svg';
import CMCIcon from './CMC.svg';
import CNXIcon from './CNX.svg';
import JNPRIcon from './JNPR.svg';
import ONBIcon from './ONB.svg';
import ADSKIcon from './ADSK.svg';
import KOIcon from './KO.svg';
import IPIcon from './IP.svg';
import INVHIcon from './INVH.svg';
import ALEIcon from './ALE.svg';
import LSCCIcon from './LSCC.svg';
import URBNIcon from './URBN.svg';

const ALL_STOCK_ICONS = {
  SSTIcon,
  CVSIcon,
  SAFTIcon,
  PTONIcon,
  ABTIcon,
  JPMIcon,
  FEIcon,
  COFIcon,
  BAFNIcon,
  MRNAIcon,
  HSTIcon,
  IMGNIcon,
  ELANIcon,
  CVNAIcon,
  VTRSIcon,
  NVSTIcon,
  KREFIcon,
  AKAMIcon,
  BERYIcon,
  BHCIcon,
  LILAKIcon,
  ROLIcon,
  OWLIcon,
  TSLAIcon,
  CNCIcon,
  BFAMIcon,
  MATIcon,
  FOURIcon,
  UNITIcon,
  DHRIcon,
  SRIcon,
  COPIcon,
  CPNGIcon,
  SPYIcon,
  CVEIcon,
  RIVNIcon,
  ILMNIcon,
  VYNEIcon,
  AALIcon,
  PATHIcon,
  METAIcon,
  GPROIcon,
  PKIcon,
  SGIcon,
  ETRNIcon,
  DDDIcon,
  VTEXIcon,
  BYNDIcon,
  GOOGLIcon,
  SNOWIcon,
  BLNKIcon,
  BRXIcon,
  PROKIcon,
  JOBYIcon,
  ANETIcon,
  SPIRIcon,
  DOCNIcon,
  PXDIcon,
  SPRXIcon,
  ZYXIIcon,
  RCLIcon,
  LHXIcon,
  RACEIcon,
  HNSTIcon,
  COTYIcon,
  FOXAIcon,
  TDOCIcon,
  NYCBIcon,
  SQIcon,
  CRWDIcon,
  DXIcon,
  LCIDIcon,
  GTIcon,
  CZRIcon,
  QGENIcon,
  SAGEIcon,
  TWOIcon,
  HLIcon,
  SHOPIcon,
  AMNIcon,
  VNOIcon,
  FISIcon,
  ABRIcon,
  RFIcon,
  MASIcon,
  SUIcon,
  OUTIcon,
  TSLQIcon,
  ACLSIcon,
  ENBIcon,
  SIRIIcon,
  ARMKIcon,
  BIRDIcon,
  BSYIcon,
  NKEIcon,
  VSTSIcon,
  BSXIcon,
  USBIcon,
  IBMIcon,
  PLDIcon,
  RCIIcon,
  ALGMIcon,
  LKQIcon,
  EOGIcon,
  ETSYIcon,
  AMCRIcon,
  FROIcon,
  TOSTIcon,
  KRIcon,
  REALIcon,
  TTDIcon,
  SOFIIcon,
  GSIcon,
  SHAKIcon,
  ELIcon,
  CLXIcon,
  PMIcon,
  CNPIcon,
  FOXFIcon,
  PANWIcon,
  RVMDIcon,
  KMBIcon,
  NEMIcon,
  HIMSIcon,
  IACIcon,
  PEAKIcon,
  CTVAIcon,
  WFCIcon,
  BRKRIcon,
  LULUIcon,
  WENIcon,
  LPXIcon,
  ETNIcon,
  SWTXIcon,
  FLEXIcon,
  NFLXIcon,
  ALGNIcon,
  DELLIcon,
  QSRIcon,
  CNQIcon,
  DISIcon,
  MTGIcon,
  CGNXIcon,
  GEIcon,
  CBREIcon,
  AMHIcon,
  SRCIcon,
  PTENIcon,
  MAIcon,
  AIGIcon,
  CPGIcon,
  SONDIcon,
  AESIcon,
  BNIcon,
  XIcon,
  TTWOIcon,
  VICIIcon,
  OIcon,
  HONIcon,
  WAFDIcon,
  DOCIcon,
  SLBIcon,
  TGTIcon,
  DUOLIcon,
  ALLYIcon,
  PLTRIcon,
  DDOGIcon,
  EQRIcon,
  WMBIcon,
  UTHRIcon,
  MODGIcon,
  CTRNIcon,
  LITEIcon,
  WMTIcon,
  KKRIcon,
  LMTIcon,
  BAXIcon,
  KIMIcon,
  EDRIcon,
  KEYIcon,
  OPKIcon,
  OTISIcon,
  ZIIcon,
  STNEIcon,
  AAPLIcon,
  SMGIcon,
  WYIcon,
  TUIcon,
  DNUTIcon,
  BXIcon,
  ADVIcon,
  AERIcon,
  TMUSIcon,
  KVYOIcon,
  HASIcon,
  SWIIcon,
  DNMRIcon,
  CPSIcon,
  MUIcon,
  SWKIcon,
  AEPIcon,
  LIcon,
  AAIcon,
  MRDBIcon,
  DOWIcon,
  ASANIcon,
  VRTIcon,
  LILAIcon,
  PSAIcon,
  BMYIcon,
  CARTIcon,
  BAMIcon,
  CFLTIcon,
  SPLKIcon,
  ARRYIcon,
  NNNIcon,
  HEROIcon,
  GFLIcon,
  LRCXIcon,
  BWAIcon,
  UAAIcon,
  NWLIcon,
  TELLIcon,
  NXTIcon,
  ROKUIcon,
  PPLIcon,
  BMOIcon,
  LACIcon,
  BLKIcon,
  JNJIcon,
  BALLIcon,
  MULNIcon,
  FTIIcon,
  WMIcon,
  MIcon,
  STWDIcon,
  ZIcon,
  CRMIcon,
  EXTRIcon,
  CLVTIcon,
  DWACIcon,
  AVGOIcon,
  SWNIcon,
  RBLXIcon,
  VFCIcon,
  SFIXIcon,
  CLIcon,
  DNAIcon,
  JCIIcon,
  UAIcon,
  VZIcon,
  FSLRIcon,
  NYTIcon,
  IONQIcon,
  GOOGIcon,
  PLUGIcon,
  LYVIcon,
  EQTIcon,
  PFEIcon,
  KSSIcon,
  NTNXIcon,
  SBRAIcon,
  LBTYBIcon,
  SPOTIcon,
  IFFIcon,
  RRCIcon,
  EGOIcon,
  IRTIcon,
  GPSIcon,
  XPIcon,
  AMGNIcon,
  VSTIcon,
  CUBEIcon,
  TDIcon,
  GROWIcon,
  ARIcon,
  CMIcon,
  HIcon,
  CRHIcon,
  MQIcon,
  ONIcon,
  MSIcon,
  AGIcon,
  SYFIcon,
  OKEIcon,
  BKIcon,
  OSCRIcon,
  DISAIcon,
  DNBIcon,
  ZMIcon,
  GOOSIcon,
  RKTIcon,
  BNSIcon,
  GOODIcon,
  DASHIcon,
  QCOMIcon,
  CAREIcon,
  ARKKIcon,
  CARRIcon,
  ROSTIcon,
  GISIcon,
  LUVIcon,
  LBTYAIcon,
  RDNTIcon,
  NCLHIcon,
  ZIONIcon,
  COHRIcon,
  LXPIcon,
  MARAIcon,
  TEAMIcon,
  KGCIcon,
  UNHIcon,
  HBANIcon,
  NXEIcon,
  HASIIcon,
  DALIcon,
  TEXIcon,
  TFCIcon,
  APAIcon,
  JWNIcon,
  KIcon,
  IBKRIcon,
  FNVIcon,
  CRKIcon,
  NIIcon,
  CSXIcon,
  AJXIcon,
  STZIcon,
  HALIcon,
  HOGIcon,
  FIcon,
  ADIIcon,
  AEMIcon,
  CCIcon,
  PARAIcon,
  RPRXIcon,
  ADBEIcon,
  HTZIcon,
  TECHIcon,
  GOLDIcon,
  RIGIcon,
  ROIVIcon,
  SPXSIcon,
  ARKGIcon,
  TENXIcon,
  LYFTIcon,
  GTLSIcon,
  FRSHIcon,
  WBDIcon,
  NOVIcon,
  NOWIcon,
  PEPIcon,
  GOAUIcon,
  LLYIcon,
  HUBCIcon,
  FLNGIcon,
  COSTIcon,
  GPKIcon,
  XPOIcon,
  LSPDIcon,
  CPRTIcon,
  SMCIIcon,
  UWMCIcon,
  ULTAIcon,
  MPWIcon,
  UPSTIcon,
  CRSRIcon,
  KVUEIcon,
  QRTEAIcon,
  TSNIcon,
  LMNDIcon,
  XELIcon,
  HCPIcon,
  RKDAIcon,
  CRSPIcon,
  XRAYIcon,
  FTVIcon,
  METIcon,
  LAMRIcon,
  TECKIcon,
  MDLZIcon,
  AEHRIcon,
  LOWIcon,
  HYMCIcon,
  BTEIcon,
  NLYIcon,
  SNDLIcon,
  NOCIcon,
  COINIcon,
  DFARIcon,
  UTIIcon,
  CVEOIcon,
  ONONIcon,
  UVVIcon,
  ABNBIcon,
  KHCIcon,
  IPGIcon,
  BARIcon,
  UBSIcon,
  UNGIcon,
  ABBVIcon,
  BILLIcon,
  GOLFIcon,
  CHWYIcon,
  FASTIcon,
  SNAIcon,
  TJXIcon,
  CRDOIcon,
  BXMTIcon,
  SIcon,
  MRKIcon,
  BEIcon,
  DIcon,
  AIIcon,
  AEOIcon,
  MPCIcon,
  STXIcon,
  SONOIcon,
  QRTEBIcon,
  NUIcon,
  AMSCIcon,
  DVNIcon,
  TPRIcon,
  BRKBIcon,
  BAIcon,
  MROIcon,
  ASTCIcon,
  WIcon,
  AMIcon,
  SANDIcon,
  AQNIcon,
  MDBIcon,
  GILDIcon,
  MBLYIcon,
  XELAIcon,
  SITCIcon,
  HUBSIcon,
  BRZEIcon,
  CSCOIcon,
  TROWIcon,
  UALIcon,
  UVEIcon,
  LBTYKIcon,
  GTLBIcon,
  PPSIIcon,
  SWKSIcon,
  CTRAIcon,
  ENPHIcon,
  MCHPIcon,
  PAGPIcon,
  MDTIcon,
  AIcon,
  ALIcon,
  VIcon,
  MOIcon,
  FLTIcon,
  GRABIcon,
  FOXIcon,
  AMPLIcon,
  ESGEIcon,
  CFIcon,
  TIcon,
  BRKAIcon,
  BBIcon,
  MGMIcon,
  WTIcon,
  SAVAIcon,
  ACHRIcon,
  EIXIcon,
  KDPIcon,
  MORFIcon,
  BBYIcon,
  LBRTIcon,
  CASHIcon,
  OPENIcon,
  LVSIcon,
  WBAIcon,
  GENIcon,
  BTUIcon,
  EEMIcon,
  BACIcon,
  SNPOIcon,
  GPNIcon,
  PSXIcon,
  FSLYIcon,
  DARIcon,
  STLAIcon,
  TQQQIcon,
  SQSPIcon,
  CFGIcon,
  PAGSIcon,
  WUIcon,
  APHIcon,
  FCXIcon,
  MSIIcon,
  UIcon,
  SYYIcon,
  MLIcon,
  SVVIcon,
  OGNIcon,
  HPIcon,
  UBERIcon,
  EWIcon,
  ZFOXIcon,
  SHCOIcon,
  CMGIcon,
  CCLIcon,
  AMATIcon,
  LOGIIcon,
  HPQIcon,
  MSFTIcon,
  CTLTIcon,
  UDRIcon,
  BIRKIcon,
  OKTAIcon,
  ABSIIcon,
  DOCSIcon,
  NXPIIcon,
  RTXIcon,
  WHRIcon,
  WRBYIcon,
  NDAQIcon,
  MTCHIcon,
  PINSIcon,
  SEDGIcon,
  OVVIcon,
  ESTCIcon,
  CARIcon,
  DKNGIcon,
  BMRNIcon,
  QSIcon,
  EAIcon,
  AMDIcon,
  VLTOIcon,
  KOSSIcon,
  PARAAIcon,
  FHNIcon,
  VLOIcon,
  SPRIcon,
  ALBIcon,
  HDIcon,
  HESIcon,
  RITMIcon,
  BASEIcon,
  DGIcon,
  FDXIcon,
  ZTSIcon,
  VTIIcon,
  SKXIcon,
  HPEIcon,
  AXPIcon,
  SCHWIcon,
  INCYIcon,
  CAGIcon,
  BKSYIcon,
  NVDAIcon,
  ROGIcon,
  LITIcon,
  DOORIcon,
  BRFIcon,
  EXCIcon,
  MANUIcon,
  PCGIcon,
  OUSTIcon,
  CMCSAIcon,
  NETIcon,
  PRVAIcon,
  KOSIcon,
  BENIcon,
  FROGIcon,
  BKRIcon,
  HRLIcon,
  SOIcon,
  XOMIcon,
  MRVLIcon,
  CVXIcon,
  CNHIIcon,
  VLYIcon,
  HOODIcon,
  HRIcon,
  NRDSIcon,
  AMCIcon,
  DPZIcon,
  AMTIcon,
  IRIcon,
  DBIcon,
  DBRGIcon,
  JETSIcon,
  PGIcon,
  QQQIcon,
  AURIcon,
  CCJIcon,
  SFMIcon,
  ORCLIcon,
  GMEIcon,
  EBAYIcon,
  CHKPIcon,
  ETRIcon,
  PENNIcon,
  SBUXIcon,
  DOCUIcon,
  GLWIcon,
  KMIIcon,
  BGCIcon,
  HIVEIcon,
  AVTRIcon,
  CATIcon,
  TSLYIcon,
  MCDIcon,
  MNSTIcon,
  CLSIcon,
  PAASIcon,
  RYIcon,
  RIOTIcon,
  DTIcon,
  AMZNIcon,
  GEHCIcon,
  PTCTIcon,
  INTCIcon,
  LOPEIcon,
  FIIcon,
  TTSHIcon,
  TXNIcon,
  GMIcon,
  PDIcon,
  CLFIcon,
  RLIcon,
  OXYIcon,
  TMOIcon,
  MMMIcon,
  CCIIcon,
  BBWIIcon,
  APTVIcon,
  IDCCIcon,
  WELLIcon,
  DXCMIcon,
  WDCIcon,
  RVTYIcon,
  AGNCIcon,
  UPSIcon,
  OPADIcon,
  NEEIcon,
  PYPLIcon,
  EMRIcon,
  COURIcon,
  AMCXIcon,
  AFRMIcon,
  FTNTIcon,
  MOSIcon,
  PRIcon,
  HAYWIcon,
  WOLFIcon,
  CMCIcon,
  CNXIcon,
  JNPRIcon,
  ONBIcon,
  ADSKIcon,
  KOIcon,
  IPIcon,
  INVHIcon,
  ALEIcon,
  LSCCIcon,
  URBNIcon,
};

export default ALL_STOCK_ICONS;
